export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=60b12fb6fff66e3141b697bbf80470b6d0840c4da7&name=fetchTypeahead!'